"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { usePatientClaim } from "@/hooks/patient-claim/use-patient-claim";
import { PurchaseAuth, PurchaseBuyer } from "@/types/shop";
import { usePatientMe } from "@/api/patient/portal-query";

/**
 * Adapter from the existing MFA OTP session to the surface-agnostic
 * `PurchaseAuth` interface. Used on the public `/{tenant}/shop` route.
 *
 * `ensureAuthenticated` is a noop here — the route's `<MfaGate>` (or the
 * `MfaDialog` component used elsewhere in self-schedule) is what actually
 * triggers OTP. Components that need to gate an action on auth just read
 * `isAuthenticated` and rely on the gate.
 */
export function useMfaPurchaseAuth() {
  const $ = _c(18);
  const {
    claimedPatient: patient
  } = usePatientClaim();
  const patientMe = usePatientMe(patient?.id ?? "", Boolean(patient));
  let t0;
  bb0: {
    if (!patient) {
      t0 = null;
      break bb0;
    }
    const t1 = patient.lastName ?? null;
    const t2 = patient.phoneNumber ?? null;
    const t3 = patient.email ?? null;
    const t4 = patient.locationId ?? null;
    const t5 = patient.primaryLocationId ?? null;
    const t6 = patient.surchargeDisabled ?? false;
    const t7 = patientMe.data?.address ?? null;
    const t8 = patientMe.data?.addressLineTwo ?? null;
    const t9 = patientMe.data?.city ?? null;
    const t10 = patientMe.data?.state ?? null;
    const t11 = patientMe.data?.zipCode ?? null;
    let t12;
    if ($[0] !== patient.firstName || $[1] !== patient.id || $[2] !== t1 || $[3] !== t10 || $[4] !== t11 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
      t12 = {
        id: patient.id,
        firstName: patient.firstName,
        lastName: t1,
        phoneNumber: t2,
        email: t3,
        locationId: t4,
        primaryLocationId: t5,
        surchargeDisabled: t6,
        address: t7,
        addressLineTwo: t8,
        city: t9,
        state: t10,
        zipCode: t11
      };
      $[0] = patient.firstName;
      $[1] = patient.id;
      $[2] = t1;
      $[3] = t10;
      $[4] = t11;
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
      $[9] = t6;
      $[10] = t7;
      $[11] = t8;
      $[12] = t9;
      $[13] = t12;
    } else {
      t12 = $[13];
    }
    t0 = t12;
  }
  const buyer = t0;
  const ensureAuthenticated = _temp;
  const t1 = Boolean(patient);
  const t2 = Boolean(patient) && patientMe.isPending;
  let t3;
  if ($[14] !== buyer || $[15] !== t1 || $[16] !== t2) {
    t3 = {
      buyer,
      isAuthenticated: t1,
      isBuyerLoading: t2,
      ensureAuthenticated
    };
    $[14] = buyer;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}
function _temp() {}